import { InternalLink } from '../../../InternalLink';
import { getItemCaption } from '../../utils/getItemCaption';
import { getModuleLink } from '../../utils/getModuleLink';
import styles from './NavigationSideItemMenu.module.scss';

export const NavigationSideItemMenu = ({ subItems, close }) => {
    return (
        <div className={styles['container']}>
            <div className={styles['items']}>
                {subItems.map(item => (
                    <InternalLink key={item.id} className={styles['link']} path={getModuleLink(item)} onClick={close}>
                        {getItemCaption(item)}
                    </InternalLink>
                ))}
            </div>
        </div>
    );
};
